import { isConcluded, isTemplate } from '@flow/libs/agreement';

import toast from '@app/components/toasts';
import { T } from '@app/components/translation';

import { getUnassignedSignatureFields } from './helpers';

import { UnassignedFieldsToastButton } from './unassigned-fields-toast-button';

export const UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID = 'unassigned-signature-fields';

export const renderGuestUnassignedFieldsToast = () => {
  toast.warning({
    id: UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID,
    title: (
      <T
        _str="Unassigned Signature fields"
        _comment="Info text explaining that the document has unassigned fields."
      />
    ),
    description: (
      <T
        _str="Contact the document owner to assign all the Signature fields."
        _comment="Notification message for unassigned fields"
      />
    ),
  });
};

export const renderUnassignedFieldsToast = ({
  agreement,
  signAttempted,
  isGuest,
}: {
  agreement: Oneflow.Agreement;
  signAttempted: boolean;
  isGuest: boolean;
}) => {
  if (!signAttempted && (isGuest || isTemplate(agreement) || isConcluded(agreement))) {
    return;
  }

  const unassignedFields = getUnassignedSignatureFields(agreement);

  if (signAttempted && isGuest && unassignedFields.length > 0) {
    renderGuestUnassignedFieldsToast();
    return;
  }

  const shouldShowOwnerToast = unassignedFields.length > 0;

  if (shouldShowOwnerToast) {
    toast.warning({
      id: UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID,
      title: (
        <T
          _str="Unassigned Signature fields"
          _comment="Info text explaining that the document has unassigned fields."
        />
      ),
      description: (
        <T
          _str="You have {count} unassigned Signature fields."
          _comment="Info text explaining that if the user makes changes to the document or to the participants, the signatures might be reset."
          count={unassignedFields.length}
        />
      ),
      action: <UnassignedFieldsToastButton />,
    });
  }
};
